import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [
// 幸运四商品
{
  path: "/luckFourGoodsManage/:storeId",
  name: "luckFourGoodsManage",
  component: function component() {
    return import("../../../views/o2o/store_luck_four/luck_four_goods_manage.vue");
  },
  meta: {
    title: "幸运四商品管理",
    foot: true
  }
},
// 选择幸运四商品
{
  path: "/chooseGoods/:storeId",
  name: "chooseGoods",
  component: function component() {
    return import("../../../views/o2o/store_luck_four/choose_goods.vue");
  },
  meta: {
    title: "选择幸运四商品",
    foot: true
  }
},
// 编辑幸运四商品
{
  path: "/editGoods/:goodsId/:storeId?",
  name: "editGoods",
  component: function component() {
    return import("../../../views/o2o/store_luck_four/edit_goods.vue");
  },
  meta: {
    title: "编辑幸运四商品",
    foot: true
  }
},
// 门店幸运四商品详情
{
  path: "/storeGoodsDetail/:goodsId",
  name: "storeGoodsDetail",
  component: function component() {
    return import("../../../views/Activity/luck/storeLuckGoodsDetail.vue");
  },
  meta: {
    title: "门店商品详情",
    foot: true
  }
},
// 幸运四商品发布
{
  path: "/luckFourGoodsRelease/:storeId",
  name: "luckFourGoodsRelease",
  component: function component() {
    return import("../../../views/o2o/store_luck_four/luck_four_goods_release.vue");
  },
  meta: {
    title: "幸运四商品发布",
    foot: true
  }
}];